<template>
	<header-block title="Vouchers" bgcolor="white"></header-block>
	<SpendingPotButton
		:amount="savedToSpendBalance"
		@click="$router.push('/SavedToSpend')"
		class="spending-pot-button"
	/>
	<h2 class="title">My Vouchers</h2>
	<div v-if="customer && vouchers">
		<MGWalletStack 
			class="wallet-stack"
			:allActiveVouchers="activeVouchers" 
			:formatter="formatter" 
			:showInitialReveal="false"
		/>
		<div style="clear:both; margin-bottom: 200px"></div>
		<div class="anchor-bottom">
			<v-row class="button-row">
				<v-col class="button-col">
					<MGButton :arrow="true" :stacked="true" text="Buy Vouchers" fullWidth="true" @click="$router.push({path: '/shopvouchers'})" />
					<MGButton :arrow="true" :stacked="true" :outline="true" text="Archived Vouchers" fullWidth="true" @click="$router.push({path: '/MyVouchers/Archived/Merchants'})" />
				</v-col>
			</v-row>
		</div>
	</div>
	<div v-else>
		<div v-for="i in 4" :key="i" class="mb-2">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
			></v-skeleton-loader>
		</div>
	</div>
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import Helpers from '../mixins/Helpers';
import MGButton from './elements/MGButton.vue';
import MGWalletStack from './elements/MGWalletStack.vue';
import SpendingPotButton from './elements/SpendingPotButton.vue';

export default {
	mixins: [Services, Helpers],
	components: { HeaderBlock,
		MGButton,
		MGWalletStack,
		SpendingPotButton },
	data() {
		return {
			balance: 0,
			discountsStatement: null,
			pollInterval: null,
			pollCount: 0,
			lastVoucherCount: 0
		}
	},
	computed: {
		savedToSpendBalance() {
			return this.discountsStatement?.savedToSpendBalance || 0;
		},
		activeVouchers() {
			const filteredVouchers = this.vouchers?.vouchers;

			// If no active vouchers, add a skeleton voucher
			if (filteredVouchers.length === 0) {
				const skeletonVoucher = {
					id: 'skeleton-voucher',
					currentBalance: 0,
					discount: {
						merchant: {
							id: 'skeleton-merchant',
							name: '',
							logoUrl: '',
							categories: ''
						},
						cardColour: '#E9E6E2',
						online: false,
						inStore: false
					},
					customerVoucherTransactions: [],
					isSkeleton: true
				};
				return [skeletonVoucher];
			}
			
			return filteredVouchers;
		},
	},
	methods: {
		getCustomer: function(){
			this._getCustomer(() => {
			});
		},
		pollVouchers: function() {
			if (this.pollCount >= 5) return;
			this.pollInterval = setTimeout(() => {
				this._getCustomerVouchers(() => {
					this.balance = this.vouchers.vouchers.reduce((a, b) => a + b.currentBalance, 0);
					this.pollCount++;
					if (this.vouchers.vouchers.length !== this.lastVoucherCount) return;
					this.pollVouchers();
				}, null, false);
			}, 2000);
		},
		onLoad: async function() {
			this.getCustomer();
			this._getDiscountsStatement((result) => {
				this.discountsStatement = result;
			});
			this._getCustomerVouchers(() =>
			{
				this.balance = this.vouchers.vouchers.reduce((a, b) => a + b.currentBalance, 0);
				this.lastVoucherCount = this.vouchers.vouchers.length;

				if (this.$route.query.poll === 'true') {
					this.pollVouchers();
				}
			}, /* merchantId */ null, /* archived */ false);
		},

	},
	mounted: function () {
		this.onLoad();
	},
	beforeUnmount: function () {
		if (this.pollInterval) {
			clearTimeout(this.pollInterval);
			this.pollInterval = null;
		}
	},
}
</script>

<style scoped>

.title {
	font-size: 14px;
	font-weight: bold;
}

.info-header {
	background-color: #ffffff44;
	border-radius: 16px;
	margin:30px;
	padding: 10px;
	margin-top: 0px;
}

.button-row {
	padding:0px;
}
.button-col {
	padding-top:0px;
}

.balance-col {
	padding-left: 20px;
	font-size: 16px;
	text-align: left;
	margin-left: 20px;
}

.balance-col-right {
	padding-left: 20px;
	font-size: 16px;
	text-align: right;
	margin-right: 30px;
}

.balance-title {
	font-size: 12px !important;
	margin-bottom: 0px;
	font-weight: lighter;
}

.wallet-stack {
	z-index: 0 !important;
}

.title {
	font-size: 20px;
	font-weight: medium;
	padding-bottom: 10px;
}

.spending-pot-button {
	margin-bottom: 16px;
}
</style>
